import { styled } from 'baseui'
import { FlexColumn } from '@/shared/theme/styled-components'

export const ModalTitle = styled('h2', ({ $theme, $pulse }) =>
  $pulse
    ? {
        margin: '0 0 20px 0',
        fontSize: '18px',
        lineHeight: '24px',
        fontWeight: 600,
        color: $theme.colors.textPulseStrong,
      }
    : {
        margin: '0 0 1rem 0',
        color: $theme.colors.primary,
        ...$theme.typography.HeadingMedium,

        '@media screen and (min-width: 768px)': {
          ...$theme.typography.HeadingLarge,
        },
      },
)

export const ModalContent = styled(FlexColumn, {
  width: '100%',
  maxWidth: '100%',
  boxSizing: 'border-box',
})

export const ModalSections = styled(FlexColumn, {})


export const SDModalPulseOverrides = () => ({
  Dialog: {
    style: ({ $theme }) => ({
      width: '90vw',
      maxWidth: '640px',
      borderTopLeftRadius: '12px',
      borderTopRightRadius: '12px',
      borderBottomRightRadius: '12px',
      borderBottomLeftRadius: '12px',
      backgroundColor: $theme.colors.white,
      boxShadow: $theme.lighting.shadowPulseModal,
    }),
  },
})

export const SDModalOverrides = () => ({
  Dialog: {
    style: ({ $theme }) => ({
      width: '75vw',
      borderTopLeftRadius: $theme.borders.radius400,
      borderTopRightRadius: $theme.borders.radius400,
      borderBottomRightRadius: $theme.borders.radius400,
      borderBottomLeftRadius: $theme.borders.radius400,

      '@media screen and (min-width: 768px)': {
        width: '640px',
        height: 'auto',
        minHeight: '380px',
        backgroundColor: $theme.colors.white,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'right bottom, center calc(100% + 50px)',
        backgroundSize: 'auto',
      },
    }),
  },
})
